import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { SessionService } from "@app/shared/services/session.service";
import { Toaster } from "./toaster.interface";


@Component({
    selector: 'app-toaster',
    templateUrl: './toaster.component.html',
    styleUrls: ["./toaster.component.scss"],
    host: {
        class: 'app-toaster'
    },
    providers: [DatePipe],
    standalone: false
})
export class ToasterComponent implements OnInit {
	@Input()
	toast: Toaster = {};

	@Input()
	counter: number = 0;

	@Output() remove = new EventEmitter<number>();

	constructor(
		private translate: TranslateService,
		public session: SessionService,
		public router: Router) {

	}

	ngOnInit(): void {
	}


}
